import Vue from 'vue';

export default function() {
  Vue.component('mena-list', () =>
    import(/* webpackChunkName: "mena-list" */ './MenaList.vue')
  );
}
